import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import { ComponentEditDialogContext, componentEditDialogInitialState } from ".";

export const ComponentEditDialogStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(componentEditDialogInitialState);
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <ComponentEditDialogContext.Provider value={context}>
      {children}
    </ComponentEditDialogContext.Provider>
  );
};
